<template>
  <section>
    <div :style="{borderColor: $store.getters.clientStyle.primary}"
      class="global-question-card container global-question-card-padding z-index2"
      @mouseover="comment.questionIsFocussed=true"
      @mouseleave="() => {if (questionData.comment==1) this.$refs.commentBox.leaveComment()}">

      <!-- Component for question title, description, number and required indicator -->
      <question-header />

      <!-- Specific markup for this question type -->
      <div class="columns global-answer-padding">

        <div class="column is-four-fifths">
          <div>
            <datepicker :value="date" v-model="date" @selected="setQuestionAnswer($event)" format="dd MMMM yyyy" placeholder="Kies datum" :language="nl"></datepicker>
          </div>
          <!-- {{formattedDate}} -->
        </div>

        <!-- button area (right side of question card) -->
        <question-options />

      </div>
    </div>

    <!-- Comment component to be redered when comments are allowed for this question -->
    <comment-box ref="commentBox" v-if="questionData.comment=='1'" />

  </section>
</template>

<script>

import QuestionHeader from './QuestionHeader'
import QuestionOptions from './QuestionOptions'
import CommentBox from './CommentBox'

import {en, nl} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    'question-header': QuestionHeader,
    'question-options': QuestionOptions,
    'comment-box': CommentBox
  },
  props: {
    questionData: Object, // eslint-disable-line vue/require-default-prop
    number: Number // eslint-disable-line vue/require-default-prop
  },
  data () {
    return {
      radio: 'default',
      answer: null,
      uploads: [],
      date: null,
      nl: nl,
      comment: {
        showComment: false,
        commentFocussed: false,
        questionIsFocussed: false
      }
    }
  },
  methods: {
    saveAnswer () {
      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')))
    },
    setQuestionAnswer (payload) {      
      this.questionData.answer = payload.toISOString().substr(0, 10)
    },
    unselect (value) {
      // console.log(value)
    },
    dateFormatter (date) {
      return moment(date).format('d M YYYY');
    }
  },
  provide () {
    return {
      question: this.questionData,
      number: this.number,
      comment: this.comment,
      uploads: this.uploads
    }
  },
  computed: {
    formattedDate () {
      return this.date.toISOString().substr(0, 10)
    }
  }
}
</script>

<style>

.radio-option {
  margin-bottom: 15px;
}

.vdp-datepicker input{
  border: 1px solid #e1e1e1;
  padding: 15px;
  font-size: 20px;
  border-radius: 5px;
}

.global-question-card.z-index2 {
  z-index: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/CalendarQuestion.vue